export default __webpack_public_path__ + "static/media/bears-eyes-get-rekt.07ec7654.jpeg";